import React from 'react';
import { useNavigate } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import buttonStyles from '~styles/buttonStyles.scss';
import {
  showCancelConfirmation,
  showCompleteConfirmation,
  approveOrder,
} from '~actions/transferActions';
import { getFormCustomContentByFormType } from '~utils/common.utils';

import { config } from '../../configuration';
import editSrc from '~images/Pake_muokkaa_sin.svg';
import flagSrc from '~images/Pake_liputa_sin.svg';
import trashSrc from '~images/Pake_peruuta_sin.svg';
import approveSrc from '~images/Pake_valmis_sin.svg';
import returnImg from '~images/Pake_paluukuljetus_sin_1.svg';
import printSrc from '~images/Pake_print_sin.svg';
import { openPrintView, closePrintView } from '~features/printOrder/ducks';
import { setShow as setModalShow, setOrderId } from '~features/modals/ducks';

const Report = ({ id }) => {
  const dispatch = useDispatch();

  return (
    <div className={buttonStyles.actionButtons}>
      <ActionButton
        action={() => {
          dispatch(setModalShow('TROUBLE_REPORT'));
          dispatch(setOrderId(id));
        }}
        img={flagSrc}
        style={{ borderBottom: 'none' }}
        buttonTxt="Ilmoita ongelmasta"
      />
    </div>
  );
};

const TaskListActionButtons = props => {
  const navigate = useNavigate();

  const goReturnOrderHandler = () =>
    navigate(
      `/palvelut/${getFormCustomContentByFormType(
        props.task.formType
      )}/paluukuljetus/${props.task.id}`
    );

  if (props.task.status === 'CANCELED') return null;

  if (props.task.status === 'COMPLETED' && !props.task.observer) {
    return <Report id={props.task.id} />;
  }

  if (props.task.status === 'COMPLETED' && props.task.observer) {
    return (
      <div className={buttonStyles.actionButtons}>
        <Report id={props.task.id} />
        <ActionButton
          action={goReturnOrderHandler}
          img={returnImg}
          buttonTxt="Tilaa paluukuljetus"
        />
      </div>
    );
  }

  // There is return transportation button in "potilaskuljetus" form
  // and approve button for orders that need approving
  const goEditOrderHandler = () =>
    navigate(
      `/palvelut/${getFormCustomContentByFormType(
        props.task.formType
      )}/muokkaa/${props.task.id}`
    );

  return (
    <div className={buttonStyles.actionButtons}>
      {props.task.modifiable && (
        <ActionButton
          img={editSrc}
          buttonTxt="Muokkaa"
          action={goEditOrderHandler}
        />
      )}
      {props.task.modifiable && (
        <ActionButton
          action={() => props.showCancelConfirmation(props.task.id)}
          img={trashSrc}
          buttonTxt="Peru"
        />
      )}
      <Report id={props.task.id} />
      {!window.cordova && props.task.printable && (
        <ActionLink
          link={`${config.apiUrl}orders/pdf/${props.task.id}`}
          img={printSrc}
          buttonTxt="Tulosta"
        />
      )}

      {/* these block buttons css is display: none in desktop view */}
      {/*
      {props.task.returnable && props.task.observer && (
        <ActionButton
          action={goReturnOrderHandler}
          img={returnImg}
          buttonTxt="Tilaa paluukuljetus"
        />
      )}
      {props.task.observer &&
        props.task.formType !== 'CUSTOM_FORM_INTERNALPACKETTRANSPORT' && (
          <ActionButton
            action={() => props.showCompleteConfirmation(props.task.id)}
            img={approveSrc}
            buttonTxt="Merkitse valmiiksi"
          />
        )}
        */}
      {props.isApprover && props.task.status === 'ORDERED' && (
        <ActionButton
          action={() => props.approveOrder(props.task.id)}
          img={approveSrc}
          buttonTxt="Hyväksy tilaus"
        />
      )}
    </div>
  );
};

const ActionButton = props => (
  <button
    type="submit"
    className={buttonStyles.actionButton}
    style={props.style}
    onClick={props.action}
  >
    <img
      role="presentation"
      src={props.img}
      className={buttonStyles.buttonIcon}
    />
    <span className={buttonStyles.buttonTextHiddenInMobile}>
      {props.buttonTxt}
    </span>
  </button>
);

const ActionLink = props => (
  <a
    className={buttonStyles.actionButton}
    href={props.link}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      role="presentation"
      src={props.img}
      className={buttonStyles.buttonIcon}
    />
    <span className={buttonStyles.buttonTextHiddenInMobile}>
      {props.buttonTxt}
    </span>
  </a>
);

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showCancelConfirmation,
      showCompleteConfirmation,
      approveOrder,
      openPrintView,
      closePrintView,
    },
    dispatch
  );
export default connect(
  state => ({
    transferTasks: state.transferReducers.transferTasks,
  }),
  mapDispatchToProps
)(TaskListActionButtons);
